import controller from './pqrs-detail.controller';
import template from './pqrs-detail.view.html';

let PqrsDetailComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default PqrsDetailComponent;



// WEBPACK FOOTER //
// ./www/components/pqrs/pqrs-detail/pqrs-detail.component.js